export default __webpack_public_path__ + "static/media/glenn-and-tommie.1bfa9963.jpeg";